
import Vue from 'vue'
import ShareButton from './ShareButton.vue'
import ModalComponent from '../ModalComponent.vue'
import store from '../../store'
import socialSharing from 'vue-social-sharing'
import { ShareLinkBuilderService} from './ShareLinkBuilder'
import { DEFAULT_BASE_URL } from './constants'

Vue.use(socialSharing)

export default Vue.extend({
  name: 'ShareComponent',
  store,
  components: {
    ShareButton,
    ModalComponent
  },
  mounted() {
    const button = document.getElementById("shareButton")
    if (!button) {
      return
    }
    button.addEventListener("click", () => {
      (this.$refs.modalComponent as any).openpopup()
    })
  },
  computed: {
    message() {
      const colors = this.$store.getters.getColors
      const shareLinkBuilderService = new ShareLinkBuilderService(DEFAULT_BASE_URL)
      const link = shareLinkBuilderService.build(colors)
      return link
    }
  },
  data() {
      return {
          copied: false
      }
  },
  methods: {
    onCopy: function (e: any) {
      this.copied = true
    },
    onError: function () {
      alert('Failed to copy texts')
    }
  }
})
